import { Modal, Button } from 'react-bootstrap';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';

const MobileCompaniesSortDrawer = ({
    showMobileSort, closeMobileSort, mobileSortOptions, draftSortField, draftSortDirection, selectDraftSort, clearMobileSortFromDrawer, applyMobileSort
}) => (
    <Modal
        className="with-form discovery-filter-mobile-modal discovery-filter-mobile-modal--fullscreen discovery-sort-mobile-modal"
        show={showMobileSort}
        onHide={closeMobileSort}
    >
        <div className="discovery-filter-mobile-panel">
            <div className="discovery-filter-mobile-panel__header">
                <Modal.Title>Sort companies</Modal.Title>
                <div className="discovery-filter-mobile-panel__header-actions">
                    <button type="button" className="discovery-filter-mobile-panel__close" onClick={closeMobileSort} aria-label="Close sort companies">
                        &times;
                    </button>
                </div>
            </div>

            <Modal.Body>
                <div className="discovery-sort-mobile-options" role="radiogroup" aria-label="Sort companies by">
                    {mobileSortOptions.map((option) => {
                        const isActive = draftSortField === option.field;
                        return (
                            <button
                                key={option.field}
                                type="button"
                                role="radio"
                                className={`discovery-sort-mobile-option${isActive ? ' is-active' : ''}`}
                                onClick={() => selectDraftSort(option.field)}
                                aria-checked={isActive}
                            >
                                <span className="discovery-sort-mobile-option__label">
                                    <span className="discovery-sort-mobile-option__radio" aria-hidden="true" />
                                    <span>{option.label}</span>
                                </span>
                                {isActive && (
                                    <span className="discovery-sort-mobile-option__direction" aria-label={draftSortDirection === 'asc' ? 'Ascending' : 'Descending'}>
                                        <span>{draftSortDirection === 'asc' ? 'Ascending' : 'Descending'}</span>
                                        {draftSortDirection === 'asc' ? <FaCaretUp aria-hidden="true" /> : <FaCaretDown aria-hidden="true" />}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </Modal.Body>

            <div className="discovery-filter-mobile-panel__footer">
                <Button
                    type="button"
                    variant="outline-secondary"
                    className="discovery-filter-mobile-panel__reset"
                    onClick={clearMobileSortFromDrawer}
                >
                    Clear sort
                </Button>

                <Button
                    type="button"
                    variant="primary"
                    className="discovery-filter-mobile-panel__apply"
                    onClick={applyMobileSort}
                >
                    Apply sort
                </Button>
            </div>
        </div>
    </Modal>
);

export default MobileCompaniesSortDrawer;
